import React from 'react';

const DoctorPhilosophy = () => {
  return (
    <div className="container mx-auto p-6">
      <div className="bg-white shadow-md rounded-lg p-6 mb-6">
        <h2 className="text-3xl font-bold mb-4">Doctor of Philosophy (PhD)</h2>
        <p className="mb-4" align="justify">
          The <strong>Doctor of Philosophy (PhD)</strong> degree is training for research and is required if you want to
          become a professor in a university or if applying for university employment. High-level scientific researchers are generally PhD
          holders. The PhD is arguably the most prestigious doctorate, but is actually awarded in dozens of fields with no direct link to the study
          of philosophy. The PhD at Hamilton College of the Bahamas is uniquely designed for professionals who are unable to
          relinquish or suspend their full-time jobs in order to pursue a doctorate. The PhD may be earned online with only two one-week
          residence requirements at the Distance Learning Center located in Barbados (or other location determined by advisor). The PhD is
          web-enhanced. With current technology it is possible to engage in: scholarly research, peer group interaction, independent study,
          mentoring by a major professor, and writing via the Internet.
        </p>
        <p className="mb-4" align="justify">
          Hamilton College of the Bahamas' programs take advantage of leading-edge technology and teaching techniques to
          assure in-depth learning. The Doctor of Philosophy degree requires a minimum of 45 credit hours.
        </p>
      </div>
    </div>
  );
};

export default DoctorPhilosophy;